<div class="l_flex guts-m-t-3 m-guts-p-h-1 m-guts-m-t-0">
  <dgx-skeleton
    [type]="isMobile ? 'verticalBlock' : 'smallVerticalBlock'"
    class="guts-p-h-1-half"
  ></dgx-skeleton>
  <div class="l_flex l_flex-column no-mobile">
    <dgx-skeleton
      type="largeVerticalBlock"
      class="guts-p-h-1-half"
    ></dgx-skeleton>
    <dgx-skeleton
      type="largeVerticalBlock"
      class="guts-p-h-1-half guts-p-t-3"
    ></dgx-skeleton>
  </div>
  <dgx-skeleton
    [type]="isMobile ? 'verticalBlock' : 'smallVerticalBlock'"
    class="guts-p-h-1-half"
  ></dgx-skeleton>
</div>
